import { useScrollableContentContext } from '../../providers';
import { useEffect, useState } from 'react';
import { InfiniteScrollTableV2Props } from './InfiniteScrollTableV2';
import type { FiltersMap } from '@wix/bex-core';

export function useInfiniteScrollTableSyncProps<T, F extends FiltersMap>(
  props: InfiniteScrollTableV2Props<T, F>,
) {
  const { state, scrollElement: scrollElementProp } = props;
  const { scrollableContentRef } = useScrollableContentContext();

  const [scrollElement, setScrollElement] = useState(
    () =>
      scrollElementProp ??
      (scrollableContentRef?.current as HTMLElement | undefined),
  );

  useEffect(() => {
    const { collection } = state;

    const scrollableContent =
      scrollElementProp ?? scrollableContentRef?.current;

    if (scrollableContent) {
      setScrollElement(scrollableContent);

      collection.scrollableContent =
        scrollableContent instanceof HTMLElement
          ? scrollableContent
          : scrollableContent.current;
    }

    return () => {
      collection.scrollableContent = null;
    };
  }, [scrollElementProp]);

  return {
    scrollElement,
  };
}
